// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

/**
 * Inits theme
 */
export function initTheme() {
  const currentSysIsDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  activateDarkMode(currentSysIsDark);
  addPrefersColorSchemeListener();
}

/**
 * Adds prefers color scheme listener
 */
function addPrefersColorSchemeListener() {
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", (e) => e.matches && activateDarkMode(true));
  window
    .matchMedia("(prefers-color-scheme: light)")
    .addEventListener("change", (e) => e.matches && activateDarkMode(false));
}

/**
 * Activates dark mode
 * @param activate
 */
function activateDarkMode(activate: boolean) {
  if (localStorage.getItem("overrideSysColour") == "true") {
    const currentColourMode = localStorage.getItem("colourMode") ?? "light";
    document.body.classList.add(currentColourMode);
  } else {
    document.body.classList.toggle("dark", activate);
  }
}
